var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-state"},[(_vm.isActivated)?[_c('div',{staticClass:"user-state__active"},[_vm._v("Active")])]:[_c('div',{staticClass:"user-state__inactive"},[_vm._v("Inactive")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }